import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button, Anchor, Menu } from 'grommet';
import { Notes, Edit, Trash, Download, Search, More } from 'grommet-icons';

import { EmptySearches, Placeholder, ErrorsSearches, Pagination, Tag } from '../../../../components';
import { Onboarding } from '../onboarding/onboarding';

import { toggleDetailsLayer } from '../../actions/details';
import { generateCsv } from '../../actions/export-csv';
import { openFormSearchLayer, goToNextPage, goToPrevPage } from '../../actions/form-search';
import { showFormManagerLayer } from '../../actions/form-manager';
import { toggleFormDeleteLayer } from '../../actions/form-delete';

import { formattedDateTime, formattedNumber } from '../../../../utils';
import rulesName from '../../../../constants/rules';

function SearchResultComponent(props) {
  const {
    userLogged: { rules, client },

    loadingFormSearch,
    dataRows,
    totalOfRows,
    getListError,

    status,
    startDate,
    endDate,
    reference,
    subject,
    participantId,
    page,
    limit,

    generateCsv,
    toggleDetailsLayer,
    showFormManagerLayer,
    toggleFormDeleteLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  } = props;

  if(loadingFormSearch && !getListError) {
    return (
      <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    );
  }

  if(getListError) {
    return <ErrorsSearches
      button={{
        label: 'Abrir filtros',
        action: openFormSearchLayer
      }}
    />;
  }

  if(!dataRows.length && client.trl) {
  //if(dataRows.length && !client.trl) {
    return <Onboarding />;
  }

  if(!dataRows.length) {
    return <EmptySearches
      buttonFilters={{
        label: 'Abrir filtros',
        action: openFormSearchLayer,
      }}

      buttonCreate={
        rules.includes(rulesName.createCall) ?
          { label: 'Nova ligação', action: showFormManagerLayer } : null
      }
    />;
  }

  const optionsMenu = (row) => {
    const options = [];

    if(rules.includes(rulesName.editCall)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Edit />
            <Text size='small'>Editar</Text>
          </Box>
        ),
        onClick: () => showFormManagerLayer(row)
      });
    }

    if(rules.includes(rulesName.deleteCall)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Trash color='status-error' />
            <Text size='small'>Excluir</Text>
          </Box>
        ),
        onClick: () => toggleFormDeleteLayer(row)
      });
    }

    return options;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => {
        return (
          <Box
            direction='row'
            justify='center'
            margin={{ horizontal: 'medium', top: '80px' }}
          >
            <Box
              pad='small'
              width='xlarge'
            >
              <Box
                align='center'
                direction='row'
                justify='between'
                margin={{ bottom: 'small' }}
              >
                <Box
                  direction={size === 'small' ? 'column' : 'row'}
                  align={size === 'small' ? 'baseline' : 'center'}
                  gap={size === 'small' ? null : 'small'}
                >
                  <Text size='xlarge'>{formattedNumber(totalOfRows)}</Text>

                  <Text
                    size={size === 'small' ? 'xsmall' : 'medium'}
                    color='dark-6'
                  >
                    {totalOfRows > 1 ? 'ligações' : 'ligação'}
                  </Text>
                </Box>

                <Box
                  direction='row'
                  align='center'
                  gap={size === 'small' ? 'large' : 'medium'}
                >
                  {rules.includes(rulesName.exportCall) &&
                    <Button
                      plain
                      title='Download Excel (.csv)'
                      icon={<Download />}
                      size='small'
                      margin={{ right: 'xsmall' }}
                      onClick={() => {
                        generateCsv({
                          status,
                          startDate: formattedDateTime(startDate),
                          endDate: formattedDateTime(endDate),
                          reference,
                          subject,
                          participantId,
                          page: 1,
                          limit: totalOfRows,
                        })
                      }}
                    />
                  }

                  <Button
                    plain
                    title='Filtrar ligações'
                    icon={<Search />}
                    onClick={() => { openFormSearchLayer() }}
                  />

                  {rules.includes(rulesName.createCall) &&
                    <Button
                      primary
                      color='neutral-1'
                      size='small'
                      label='Nova'
                      onClick={() => { showFormManagerLayer() }}
                    />
                  }
                </Box>
              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                border={{ side: 'bottom', color: 'light-5' }}
                gap='small'
              >
                {size !== 'small' && size !== 'medium' && <Box width='xsmall'>
                  <Text color='dark-2'>Ref.</Text>
                </Box>}

                {size !== 'small' && <Box width='small'>
                  <Text color='dark-2'>Cadastrado por</Text>
                </Box>}

                {size !== 'small' && size !== 'medium' && <Box width='small'>
                  <Text color='dark-2'>Data cadastro</Text>
                </Box>}

                {size !== 'small' && <Box width='medium'>
                  <Text color='dark-2'>Quem ligou</Text>
                </Box>}

                {size !== 'small' && <Box width='small'>
                  <Text color='dark-2'>Status</Text>
                </Box>}

                <Box width='small' />
              </Box>

              {dataRows.map(row => {
                const menu = optionsMenu(row);

                return (
                  <Box
                    key={row.id}
                    align='center'
                    direction='row'
                    pad={{ vertical: size === 'small' ? 'small' : 'xsmall' }}
                    border={{ side: 'bottom', color: 'light-5' }}
                    gap='small'
                  >
                    {size !== 'small' && size !== 'medium' && <Box width='xsmall'>
                      <Anchor
                        title='Abrir detalhes'
                        label={`LI-${row.id}`}
                        onClick={() => { toggleDetailsLayer(row) }}
                      />
                    </Box>}

                    {size !== 'small' && <Box width='small'>
                      <Text color='dark-2' size='small'>{row.createdBy}</Text>
                    </Box>}

                    {size !== 'small' && size !== 'medium' && <Box width='small'>
                      <Text color='dark-2' size='small'>
                        {formattedDateTime(row.createdAt, 'DD MMM YYYY HH:mm')}
                      </Text>
                    </Box>}

                    <Box width='medium'>
                      <Text color='dark-2' size='small'>
                        {row.name} {row.telephone}
                      </Text>
                    </Box>

                    <Box width='small' direction='row'>
                      <Tag text={row.status} background='dark-2' />
                    </Box>

                    <Box align='end' width='small'>
                      <Box direction='row'>
                        <Button
                          title='Abrir detalhes'
                          icon={<Notes color='dark-3' size='medium' />}
                          onClick={() => { toggleDetailsLayer(row) }}
                        />

                        {menu.length > 0 && (<Menu
                          dropProps={{ align: { right: 'right', top: 'top' } }}
                          icon={<More />}
                          items={menu}
                        />)}
                      </Box>
                    </Box>
                  </Box>
                )
              })}

              <Pagination
                totalOfRows={totalOfRows}
                nextPage={goToNextPage}
                prevPage={goToPrevPage}
                filters={{
                  status,
                  startDate: formattedDateTime(startDate),
                  endDate: formattedDateTime(endDate),
                  reference,
                  subject,
                  participantId,
                  page,
                  limit,
                }}
              />
            </Box>
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ authReducer: { authenticated }, phonecallsReducer: { searchResult, formSearch } }) => ({
  userLogged: authenticated,

  status: formSearch.status,
  startDate: formSearch.startDate,
  endDate: formSearch.endDate,
  reference: formSearch.reference,
  subject: formSearch.subject,
  participantId: formSearch.participantId,
  page: formSearch.page,
  limit: formSearch.limit,

  loadingFormSearch: searchResult.loadingFormSearch,
  dataRows: searchResult.dataRows,
  totalOfRows: searchResult.totalOfRows,
  getListError: searchResult.getListError,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    generateCsv,
    toggleDetailsLayer,
    showFormManagerLayer,
    toggleFormDeleteLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  }, dispath)
};

export const SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResultComponent);
